import React from 'react';
import '../styles/Navbar.css';

const Navbar = () => (
  <nav className="navbar">
    <h1>Payment Gateway</h1>
  </nav>
);

export default Navbar;